import "./Modal.scss"
import React, { Component } from "react"
import ReactDOM from "react-dom"
import { Motion, spring } from "react-motion"

const config = {
  stiffness: 250,
  damping: 20,
}

class ModalInsulator extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.shouldUpdate
  }
  render() {
    return this.props.children
  }
}

class Modal extends Component {
  state = {
    animating: true,
  }

  render() {
    return ReactDOM.createPortal(
      <div
        className="Modal"
        onClick={e => e.target === e.currentTarget && this.props.onClose()}>
        <Motion
          defaultStyle={{ x: 0.5 }}
          style={{ x: spring(1, config) }}
          onRest={() => this.setState({ animating: false })}>
          {i => (
            <div
              {...this.props}
              className="Modal_content"
              style={{ transform: `scale(${i.x})` }}>
              <ModalInsulator shouldUpdate={!this.state.animating}>
                {this.props.children}
              </ModalInsulator>
            </div>
          )}
        </Motion>
      </div>,
      document.body
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/lib/Modal.js